import React from "react";

const SocialHandles: React.FC = () => {
  const socialLinks = [
    {
      name: "X (Twitter)",
      url: "https://x.com/StreakSpark",
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
        </svg>
      ),
    },
    {
      name: "Facebook",
      url: "https://www.facebook.com/streak.spark",
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
        </svg>
      ),
    },
    {
      name: "Instagram",
      url: "https://www.instagram.com/streak.spark/",
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12.017 0C8.396 0 7.996.014 6.802.067 5.618.12 4.902.255 4.28.511c-.66.267-1.22.628-1.78 1.188-.56.56-.921 1.12-1.188 1.78C.755 4.902.62 5.618.567 6.802.514 7.996.5 8.396.5 12.017s.014 4.021.067 5.215c.053 1.184.188 1.9.444 2.522.267.66.628 1.22 1.188 1.78.56.56 1.12.921 1.78 1.188.622.256 1.338.391 2.522.444 1.194.053 1.594.067 5.215.067s4.021-.014 5.215-.067c1.184-.053 1.9-.188 2.522-.444.66-.267 1.22-.628 1.78-1.188.56-.56.921-1.12 1.188-1.78.256-.622.391-1.338.444-2.522.053-1.194.067-1.594.067-5.215s-.014-4.021-.067-5.215c-.053-1.184-.188-1.9-.444-2.522-.267-.66-.628-1.22-1.188-1.78-.56-.56-1.12-.921-1.78-1.188-.622-.256-1.338-.391-2.522-.444C16.021.014 15.621 0 12.017 0zm0 1.802c3.538 0 3.958.013 5.356.066 1.302.05 2.012.217 2.476.362.603.188 1.032.414 1.482.864.45.45.676.879.864 1.482.145.464.312 1.174.362 2.476.053 1.398.066 1.818.066 5.356s-.013 3.958-.066 5.356c-.05 1.302-.217 2.012-.362 2.476-.188.603-.414 1.032-.864 1.482-.45.45-.879.676-1.482.864-.464.145-1.174.312-2.476.362-1.398.053-1.818.066-5.356.066s-3.958-.013-5.356-.066c-1.302-.05-2.012-.217-2.476-.362-.603-.188-1.032-.414-1.482-.864-.45-.45-.676-.879-.864-1.482-.145-.464-.312-1.174-.362-2.476C2.663 8.835 2.65 8.415 2.65 5.877s.013-3.958.066-5.356c.05-1.302.217-2.012.362-2.476.188-.603.414-1.032.864-1.482.45-.45.879-.676 1.482-.864.464-.145 1.174-.312 2.476-.362C8.059 1.815 8.479 1.802 12.017 1.802zm0 3.293a6.522 6.522 0 100 13.044 6.522 6.522 0 000-13.044zm0 10.764a4.242 4.242 0 110-8.484 4.242 4.242 0 010 8.484zm6.406-11.845a1.44 1.44 0 11-2.88 0 1.44 1.44 0 012.88 0z" />
        </svg>
      ),
    },
  ];

  return (
    <div className="flex justify-center space-x-6 py-6">
      {socialLinks.map((link) => (
        <a
          key={link.name}
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
          className="text-neutral-600 dark:text-neutral-400 hover:text-primary-600 dark:hover:text-primary-400 transition-colors duration-300"
          aria-label={link.name}
        >
          {link.icon}
        </a>
      ))}
    </div>
  );
};

export default SocialHandles;
